var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M21.7392 11.07C21.6892 10.56 21.2592 10.18 20.7492 10.18H13.1992C12.6492 10.18 12.1992 10.63 12.1992 11.18V12.89C12.1992 13.44 12.6492 13.89 13.1992 13.89H17.7092C17.5992 14.81 16.9992 16.2 15.6692 17.13C14.8192 17.72 13.6892 18.13 12.1992 18.13C12.1292 18.13 12.0692 18.13 11.9992 18.12C9.44922 18.04 7.28922 16.33 6.50922 13.98C6.29922 13.35 6.17922 12.69 6.17922 12C6.17922 11.31 6.29922 10.64 6.49922 10.02C6.55922 9.83999 6.62922 9.66001 6.70922 9.48001C7.62922 7.41001 9.63922 5.95 11.9992 5.88C12.0592 5.87 12.1292 5.87 12.1992 5.87C13.6292 5.87 14.6992 6.33999 15.4492 6.85999C15.8392 7.12999 16.3592 7.06999 16.6992 6.73999L18.0892 5.38C18.5292 4.95 18.4892 4.21999 17.9892 3.85999C16.3992 2.68999 14.4592 2 12.1992 2C12.1292 2 12.0692 2.00001 11.9992 2.01001C8.16922 2.08001 4.87922 4.30001 3.26922 7.51001C2.58922 8.87001 2.19922 10.39 2.19922 12C2.19922 13.61 2.58922 15.13 3.26922 16.49H3.27922C4.88922 19.7 8.17922 21.92 11.9992 21.99C12.0692 22 12.1292 22 12.1992 22C14.8992 22 17.1692 21.11 18.8192 19.58C20.7092 17.83 21.7992 15.27 21.7992 12.22C21.7992 11.79 21.7792 11.42 21.7392 11.07Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }